"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _fileInput = _interopRequireDefault(require("@uppy/file-input"));
var propTypes = _interopRequireWildcard(require("./propTypes.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * React component that renders an area in which files can be dropped to be
 * uploaded.
 */
var FileInput = /*#__PURE__*/function (_Component) {
  function FileInput() {
    _classCallCheck(this, FileInput);
    return _callSuper(this, FileInput, arguments);
  }
  _inherits(FileInput, _Component);
  return _createClass(FileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.installPlugin();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // eslint-disable-next-line react/destructuring-assignment
      if (prevProps.uppy !== this.props.uppy) {
        this.uninstallPlugin(prevProps);
        this.installPlugin();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallPlugin();
    }
  }, {
    key: "installPlugin",
    value: function installPlugin() {
      var _this$props = this.props,
        uppy = _this$props.uppy,
        locale = _this$props.locale,
        pretty = _this$props.pretty,
        inputName = _this$props.inputName;
      var options = {
        id: 'react:FileInput',
        locale: locale,
        pretty: pretty,
        inputName: inputName,
        target: this.container
      };
      uppy.use(_fileInput.default, options);
      this.plugin = uppy.getPlugin(options.id);
    }
  }, {
    key: "uninstallPlugin",
    value: function uninstallPlugin(props) {
      if (props === void 0) {
        props = this.props;
      }
      var _props = props,
        uppy = _props.uppy;
      uppy.removePlugin(this.plugin);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/(0, _react.createElement)('div', {
        className: 'uppy-Container',
        ref: function ref(container) {
          _this.container = container;
        }
      });
    }
  }]);
}(_react.Component);
// Must be kept in sync with @uppy/file-input/src/FileInput.jsx
FileInput.defaultProps = {
  locale: undefined,
  pretty: true,
  inputName: 'files[]'
};
var _default = exports.default = FileInput;